import { useEffect,useState } from "react";
import api from "../api/api";

export default function Timeline(){

 const [data,setData]=useState([]);

 useEffect(()=>{
  load();
 },[]);

 const load = async()=>{
  const res = await api.get("/dashboard/recent-activities");
  setData(res.data);
 };

 return(

 <div className="ml-64 p-6">

 <h2 className="text-xl mb-4">Activity Timeline</h2>

 <div className="flex flex-col gap-4">

 {data.map((a,i)=>(
 <div key={i} className="border-l-4 border-blue-500 pl-4">

 <div className="font-bold">{a.activity_type}</div>
 <div>{a.description}</div>
 <div className="text-sm text-gray-500">{a.created_at}</div>

 </div>
 ))}

 </div>

 </div>

 );
}